import type { Criterion, Milestone, Prize } from "../types/hackathon";

export const program = {
  name: "Vibe Engineering Hackathon",
  edition: "October 2026",
  summary:
    "Five cross-border teams from Brazil and India have six days to take a hardware product from idea to working prototype, then pitch it live to investors on Demo Day.",
  demoDayLabel: "Tuesday, October 13, 2026",
};

export const partners = [
  {
    name: "Link School of Business",
    role: "Academic partner · Brazil",
    description: "Business school bringing six students with venture and product backgrounds.",
  },
  {
    name: "Mahindra University",
    role: "Academic partner · India",
    description: "University bringing five students with engineering and design backgrounds.",
  },
  {
    name: "Circuit Launch",
    role: "Host & hardware lab",
    description: "Cofacturing for mechatronic engineering.",
  },
];

export const prizes: Prize[] = [
  { place: 1, label: "1st place", amount: "$1,500" },
  { place: 2, label: "2nd place", amount: "$750" },
  { place: 3, label: "3rd place", amount: "$300" },
  { place: 4, label: "4th place", amount: "Prize to be announced" },
  { place: 5, label: "5th place", amount: "Prize to be announced" },
];

export const criteria: Criterion[] = [
  { id: "problem", label: "Problem & market", weight: 20, description: "Is the problem real, painful and big enough?" },
  { id: "innovation", label: "Innovation", weight: 20, description: "How new and defensible is the solution?" },
  { id: "prototype", label: "Prototype", weight: 25, description: "Does the hardware work, and how far did the team get?" },
  { id: "business", label: "Business model", weight: 15, description: "Is there a credible path to revenue?" },
  { id: "pitch", label: "Pitch delivery", weight: 20, description: "Clarity, story and handling of Q&A." },
];

export const milestones: Milestone[] = [
  { id: "problem", label: "Problem defined and validated", day: 1 },
  { id: "concept", label: "Product concept and sketches", day: 2 },
  { id: "bom", label: "Bill of materials sourced", day: 3 },
  { id: "prototype", label: "Working prototype v1", day: 4 },
  { id: "testing", label: "Tested with real users", day: 5 },
  { id: "pitch", label: "Pitch deck and demo ready", day: 6 },
];

export const rules = [
  "Teams build one hardware product connected to their assigned track.",
  "Each team uploads one progress video per day, up to 2 minutes, by 21:00.",
  "All code, designs and parts lists are shared with mentors by Day 6.",
  "Demo Day pitches are 5 minutes plus 3 minutes of Q&A.",
  "Pitches are streamed and scored by AI against the published criteria; investors confirm the final ranking.",
];
